/**
 * @param {number} num
 *
 * @return {number} Rounded to the nearest two decimal places.
 */
export function round2(num: any) {
	return Math.round(num * 100) / 100;
}

/**
 * @param {number} num
 *
 * @return {number} Rounded to the nearest two decimal places.
 */
export function round3(num: any) {
	return Math.round(num * 1000) / 1000;
}

/**
 * @param {number} num
 *
 * @return {number} Rounded up to the nearest two decimals.
 */
export function roundUp2(num: number) {
	// return Number(Math.round(num + 'e' + 2) + 'e-' + 2);
}

/**
 * Strip commas from string.
 *
 * @param {String} string
 */
export function stripCommas(string: any) {
	return string.replace(/,/g, '');
}

/**
 * @param {number|string} num
 *
 * @return {string} Number in string format with thousands separators (commas).
 */
export function addThousandSeparators(num: any) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * @param {val} string
 *
 * @return {number}
 */
export function toNumber(val: any) {
	// Ignore if already a number
	if (typeof val === 'number') {
		return val;
	} else {
		return parseFloat(stripCommas(val)) || 0;
	}
}

/**
 * The following functions help `toCurrency` with formatting for currency.
 */

const getDigitsFromValue = (value = '') =>
	value.replace(/(-(?!\d))|[^0-9|-]/g, '') || '';

const padDigits = (digits: any) => {
	const desiredLength = 3;
	const actualLength = digits.length;

	if (actualLength >= desiredLength) {
		return digits;
	}

	const amountToAdd = desiredLength - actualLength;
	const padding = '0'.repeat(amountToAdd);

	return padding + digits;
};

const removeLeadingZeros = (number: any) => number.replace(/^0+([0-9]+)/, '$1');

const addDecimalToNumber = (number: any, separator: any) => {
	const centsStartingPosition = number.length - 2;
	const dollars = removeLeadingZeros(
		number.substring(0, centsStartingPosition)
	);
	const cents = number.substring(centsStartingPosition);
	return dollars + separator + cents;
};

/**
 * @param {string|number} value
 * @param {string} separator
 */
export const toCurrency = (value: any, separator = '.') => {
	// Make sure numbers get converted to string with two decimal places.
	if (typeof value === 'number') {
		value = value.toFixed(2);
	}

	const digits = getDigitsFromValue(value);
	const digitsWithPadding = padDigits(digits);
	const digitsWithDecimal = addDecimalToNumber(digitsWithPadding, separator);
	return addThousandSeparators(digitsWithDecimal);
};

export const getRealEstateCommissionPercent = (price: any, commission: any) => {
	price = toNumber(price);
	commission = toNumber(commission);

	// Since we're dividing, if we get two zeros we'll end up with NaN.
	if (price && commission) {
		return String(round3((commission / price) * 100)) || 0;
	} else {
		return '0';
	}
};

export const getRealEstateCommission = (price: any, percent: any) => {
	price = toNumber(price);
	percent = toNumber(percent);
	const commission = ((price * percent) / 100).toFixed(2);
	return commission;
};
